import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/ConfirmModal/ConfirmModal';
import { SettingsIcon } from '@/components/ui/Icons/Icons';
import { Overlay } from '@/components/ui/Overlay/Overlay';
import { Swipeable } from '@/components/ui/Swipeable/Swipeable';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { ROUTES } from '@/constants/common';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useSignOut } from '@/hooks/useSignOut';

import * as S from './ProfileMenuMobile.styles';

export const ProfileMenuMobile = () => {
  const isLaptop = useMediaQuery('laptop');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const path = usePathname();
  const isProfilePage = path.startsWith(ROUTES.PROFILE);

  const handleSignout = useSignOut();

  const { t } = useTranslation();

  if (!isLaptop) return null;

  const handleTogglePopup = () => setIsPopupOpen(prev => !prev);

  const handleToggleModal = () => setIsModalOpen(prev => !prev);

  const handleModalOpen = () => {
    handleTogglePopup();
    handleToggleModal();
  };

  return (
    <>
      {isProfilePage && (
        <S.ToggleButton onClick={handleTogglePopup}>
          <SettingsIcon />
        </S.ToggleButton>
      )}

      {isPopupOpen && <Overlay zIndex={50} onClick={handleTogglePopup} />}
      <Swipeable onSwipeDown={handleTogglePopup}>
        <S.Popup $isOpen={isPopupOpen}>
          <Typography variant="h4">
            {t('ProfileMenu.settings_label')}
          </Typography>

          <S.PopupItemLogout onClick={handleModalOpen}>
            <Typography variant="body2">
              {t('ProfileMenu.signout_button_label')}
            </Typography>
          </S.PopupItemLogout>
        </S.Popup>
      </Swipeable>

      {isModalOpen && (
        <ConfirmModal
          title={t('ProfileMenu.modal_title')}
          subtitle={t('ProfileMenu.modal_subtitle')}
          confirmLabel={t('ProfileMenu.signout_button_label')}
          cancelLabel={t('ProfileMenu.cancel_button_label')}
          onConfirm={handleSignout}
          onCancel={handleToggleModal}
        />
      )}
    </>
  );
};
